import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CircularProgress from '@mui/material/CircularProgress';

import RichTextEditor from './RichTextEditor';
import {BluePillButton} from '../../common/components/BluePillButton';
import {LESSON} from '../../constants';

import baseStyles from '../../css/Base.module.css';

export default function Instructions({
  instructionsHTML,
  setInstructionsHTML,
  setInstructionsPlainText,
  handleClickCancel,
  handleSaveInstructions,
  type,
}) {
  const [isSaving, toggleIsSaving] = useState(false);

  const entity = type === LESSON ? 'lesson' : 'exercise';

  async function handleClickSave() {
    toggleIsSaving(true);
    await handleSaveInstructions();
    toggleIsSaving(false);
  }

  return (
    <>
      <div className="p-lr-15 p-b-15">
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className="clr-dark-blue fnt-bold">
              Printable Instructions
            </Typography>
            <Typography variant="body2" className="fnt-bold">
              {`These instructions will help other educators on how you envision this ${entity} to be implemented.`}
            </Typography>

            <div className="p-t-10">
              <RichTextEditor
                html={instructionsHTML}
                setHTML={setInstructionsHTML}
                setPlainText={setInstructionsPlainText}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <AppBar position="fixed" className="bg-gray-100" sx={{top: 'auto', bottom: 0}}>
        <Toolbar>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button className={baseStyles['btn-pill']} onClick={handleClickCancel}>
              Cancel
            </Button>
            <BluePillButton variant="outlined" onClick={handleClickSave}>
              {isSaving ? <CircularProgress size={25} /> : 'Save'}
            </BluePillButton>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Makes AppBar at the bottom of the page */}
    </>
  );
}
